import React from 'react';
import { PaymentDetails } from '../../logic/components';

const PaymentRoute = () => {
  return (
    <div className="container">
      <PaymentDetails />
    </div>
  );
};

export default PaymentRoute;
